import { useConfig, type AppConfig } from "app/contexts/ConfigContext";

/**
 * Whether `config` turns Token Custodian on (the "token-custodian" dev flag),
 * for callers handed the config rather than reading it from context.
 */
export function isTokenCustodianAvailable(config: AppConfig | null) {
  return Boolean(config?.dev_flags?.includes("token-custodian"));
}

/** Whether Token Custodian is available (the "token-custodian" dev flag). */
export function useIsTokenCustodianAvailable() {
  return isTokenCustodianAvailable(useConfig());
}
